"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/progress/style");
var _progress = _interopRequireDefault(require("antd/lib/progress"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Progress.less");
var _excluded = ["thin"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Progress = function Progress(props) {
  var thin = props.thin,
    antdProps = _objectWithoutProperties(props, _excluded);
  var extraProps = {};
  if (thin) {
    extraProps = {
      className: 'progress-thin',
      strokeLinecap: 'square',
      strokeColor: '#3d5868',
      strokeWidth: 2
    };
  }
  return /*#__PURE__*/_react.default.createElement(_progress.default, _extends({}, antdProps, extraProps));
};
Progress.propTypes = {
  showInfo: _propTypes.default.bool,
  percent: _propTypes.default.number,
  thin: _propTypes.default.bool
};
var _default = Progress;
exports.default = _default;